$(document).ready(function(){
    $(document).on('change', '#markPayoutrequest', function () {
        if ($("#markPayoutrequest").val() === "deny"){
            $('#hideUnlessMarkDenied').show();
        }else{
            $('#hideUnlessMarkDenied').hide();
        }
    });
});
